import { useState } from 'react'
import { Outlet, matchPath, useLocation } from 'react-router-dom'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'

import { useResponsive } from '@/hooks/useResponsive'
import { usePushNotifications } from '@/hooks/usePushNotifications'
import { useWebPushNotifications } from '@/hooks/useWebPushNotifications'
import AppHeader from './AppHeader'
import Sidebar, { DRAWER_WIDTH } from './Sidebar'

const MainLayout = () => {
    const { isDesktop } = useResponsive()
    const { pathname } = useLocation()
    const isStatisticsPage = ['/counters', '/sipStatistics', '/environmental'].some(
        (path) => matchPath(path, pathname)
    )
    const [drawerOpen, setDrawerOpen] = useState(false)
    usePushNotifications()
    useWebPushNotifications()

    const toggleDrawer = () => setDrawerOpen((prev) => !prev)

    return (
        <Box sx={{
            display: 'flex',
            minHeight: '100dvh',
            height: isStatisticsPage ? '100dvh' : undefined,
            overflow: isStatisticsPage ? 'hidden' : undefined
        }}>
            {/* Sidebar: permanent on desktop, temporary on mobile/tablet */}
            {isDesktop ? (
                <Sidebar variant='permanent' open />
            ) : (
                <Sidebar
                    variant='temporary'
                    open={drawerOpen}
                    onClose={() => setDrawerOpen(false)}
                />
            )}

            {/* Main content area */}
            <Box
                component='main'
                sx={{
                    flexGrow: 1,
                    width: isDesktop ? `calc(100% - ${DRAWER_WIDTH}px)` : '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 0
                }}>
                <AppHeader onMenuToggle={toggleDrawer} showMenuButton={!isDesktop} />
                {/* Spacer for fixed AppBar: Box separado para el safe-area (un Toolbar vacío no
                    crece con padding porque su min-height con box-sizing:border-box lo absorbe) */}
                <Box sx={{ height: 'env(safe-area-inset-top)', flexShrink: 0 }} />
                <Toolbar sx={{ flexShrink: 0 }} />
                <Box
                    sx={{
                        flexGrow: 1,
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                        pt: { xs: 2, sm: 3 },
                        px: { xs: 2, sm: 3 },
                        // pb separado para que no compita con el shorthand 'p'.
                        // env() con fallback 0px para webviews que no lo soporten.
                        pb: { xs: 2, sm: 3 },
                        bgcolor: 'background.default'
                    }}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    )
}

export default MainLayout
